import React, { useEffect, useMemo, useState } from 'react';
import { LookerReportType, ReportInfoType } from '../type';
import { getLooker } from '@/pages/home/services/report';
import classNames from 'classnames';
import '../index.scss';
import ErrorInfo from '../component/errorInfo';
import Loading from '@/pages/dashboard/components/Loadings';
import { getLocale } from 'umi';

const INIT_REPORT_INFO: ReportInfoType = {
  loading: true,
  noReport: false,
  reportUrl: '',
  errMsg: ''
};

export default (props: LookerReportType) => {
  const { url, models, className, style, onSuccess, onFail} = props || {};
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const locale = getLocale();
  const isEn = locale === 'en-US';

  useEffect(() => {
    const openIframeReport = () => {
      setReportInfo({
        ...INIT_REPORT_INFO,
      });
  
      const params = {
        url: url || '',
        looker_models: models || '',
      };
  
      getLooker(params)
        .then((data) => {
          setReportInfo({
            loading: false,
            reportUrl: data?.url || '',
            errMsg: data?.msg || '',
            noReport: !data?.url,
          });
          onSuccess?.();
        })
        .catch(() => {
          setReportInfo({
            ...INIT_REPORT_INFO,
            loading: false,
            noReport: true,
          });
          onFail?.();
        });
    };
    
    openIframeReport();
  }, [url, models]);

  const errorInfo = useMemo(() => {
    if (reportInfo.noReport) {
      return <ErrorInfo isEn={isEn} />;
    }
    return null;
  }, [reportInfo.noReport, isEn]);

  return (
    <>
      {reportInfo.loading ? (
        <Loading />
      ) : (
        <>
          {errorInfo || (
            <div className={classNames('dtb-db-iframe-wrap db-report-looker', className)} style={style}>
              <iframe
                title="looker"
                className='dtb-db-iframe'
                src={reportInfo.reportUrl}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};
